import { DebugToken } from '../types/DebugToken';
import poliApiGatewayRequest from 'src/utils/poliApiGatewayRequest';

// DEV4-5481: sempre pelo meta-business-management, com ou sem a flag
// `request_graph_api_from_waba_service`. O `debug_token` exige o token do
// usuário de sistema, que não pode estar no navegador.
const getWabasFromDebugToken = async (
  token: string
): Promise<string[] | undefined> => {
  try {
    const response = await poliApiGatewayRequest.get(`/waba/token/${token}`);

    const data: DebugToken | undefined = response?.data?.data;
    if (!data) {
      console.error('getWabasFromDebugToken: No data returned from API');
      return undefined;
    }

    const foundScopeWBM = data.granular_scopes?.find((e) => {
      return e.scope === 'whatsapp_business_management';
    });

    if (foundScopeWBM && foundScopeWBM.target_ids) {
      console.log(`Found ${foundScopeWBM.target_ids.length} WABA(s) for token`);
      return foundScopeWBM.target_ids;
    } else {
      console.error(
        'getWabasFromDebugToken: Token does not have whatsapp_business_management scope '
        + 'or no WABA accounts found. User may not have the required permissions.'
      );
      return undefined;
    }
  } catch (error: any) {
    const axiosError = error;
    
    if (axiosError.response) {
      const status = axiosError.response.status;
      const errorData: any = axiosError.response.data;
      
      console.error(
        `getWabasFromDebugToken: API Error (${status}):`,
        errorData?.error?.message || errorData?.message || 'Unknown error'
      );
      
      // Log specific OAuth errors from Facebook
      if (errorData?.error?.code === 100) {
        console.error(
          'OAuth Error #100: Invalid or missing access token. '
          + 'The user token is invalid or the backend Meta token is not configured.'
        );
      }
    } else if (axiosError.request) {
      console.error('getWabasFromDebugToken: No response received from server');
    } else {
      console.error('getWabasFromDebugToken: Error setting up request:', axiosError.message);
    }
    
    // Re-throw to allow upper layers to handle
    throw error;
  }
};

export { getWabasFromDebugToken };
